module.exports = __webpack_public_path__ + "static/media/smile.1ede85d0.svg";